<template>
  <div class="wrapper app-content">
    <div class="tilte-text"> 公众号授权 </div>
    <div class="auth-wrap">
      <div class="auth-box" v-if="authStep == 1">
        <el-row>
          <el-col :span="6" class="auth-logo-div">
            <img class="auth-logo" src="../../../../assets/img/official/wechat_shouquanshuoming.png" alt="">
          </el-col>
          <el-col :span="18">
            <div class="auth-title">授权说明</div>
            <div class="auth-tip">
              <div class="part-box">
                <div class="part-circle"></div>
                <div class="part-content"><span>授权过程需要该公众号的管理员扫码，管理员一般是注册公众号的人，运营者是不能授权的。</span></div>
              </div>
              <div class="part-box">
                <div class="part-circle"></div>
                <div class="part-content"><span>如果你是公众号的管理员，点击下方按钮，扫码授权即可。</span></div>
              </div>
              <div class="part-box">
                <div class="part-circle"></div>
                <div class="part-content">
                  <span>如果你是公众号的运营者，点击下方按钮，在授权二维码出来后，把二维码截图发给管理员，授权过程中请不要关闭当前页面，等对方扫码通过后，这边就可以授权成功了。</span></div>
              </div>
              <div class="btn-box">
                <span class="auth-btn">
                  <a :href="authLink" target="_blank">点击开始授权公众号</a>
                </span>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>

    <div class="auth-detail" v-if="authStep == 2">
      <el-row>
        <el-col :span="13" class="left-box">
          <div class="detail-box">
            <div class="detail-div">
              <div class="operate-div">
                <div>
                  <img v-if="headImg" :src="headImg" alt="">
                  <img v-else src="../../../../assets/img/official/weishouquan.png" alt="">
                </div>
                <div class="wechat-title">{{ platformName }}</div>
                <div><span class="wechat-btn" @click="syncTemplate()">同步消息模板</span></div>
                <div><span class="wechat-btn" @click="bindWechatAdmin()">绑定微信管理员</span></div>
              </div>
              <div class="link-div">
                <div class="link-title">
                  您的影票专属推广链接为：
                </div>
                <div class="link">
                  <a target="_blank" :href="promotionLink">{{ promotionLink }}</a>
                </div>
                <div v-show="!isBasic">
                  <div class="link-title">
                    其他页面链接：
                  </div>
                  <div class="link">
                    <label>个人中心</label><a target="_blank" :href="personalLink">{{ personalLink }}</a>
                    <div>
                      <div class="copy-btn" @click="copyLink(personalLink)">复制链接</div>
                    </div>
                  </div>
<!--                  <div class="link">-->
<!--                    <label>邀请好友</label><a target="_blank" :href="posterLink">{{ posterLink }}</a>-->
<!--                    <div>-->
<!--                      <div class="copy-btn" @click="copyLink(posterLink)">复制链接</div>-->
<!--                    </div>-->
<!--                  </div>-->
                </div>
<!--                <div class="link-tip">-->
<!--                  将链接放于您的公众号菜单栏中，会员点击菜单就可以专属购票页面，订单结算后您将获得订单利润分佣。-->
<!--                </div>-->
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="11" class="right-box">
          <div class="notice-box">
            <div class="auth-title">注意事项</div>
            <div class="auth-tip">
              <div class="part-box">
                <div class="part-circle"></div>
                <div class="part-content"><span>授权成功后，请先<span class="sync-template"
                      @click="syncTemplate()">同步消息模版</span></span></div>
              </div>
              <div class="part-box">
                <div class="part-circle"></div>
                <div class="part-content"><span>不要手动去删除微信公众号生成的消息模板</span></div>
              </div>
              <div class="part-box">
                <div class="part-circle"></div>
                <div class="part-content"><span>有任何出券码的问题，及时联系客服处理</span></div>
              </div>
            </div>
            <div class="qrcode-box">
              <div class="qrcode-div margin-right-10">
                <img class="qrcode-img" src="../../../../assets/img/official/service1.jpg" alt="">
                <div class="nickname">守兔票务-雪糕</div>
              </div>
              <div class="qrcode-div margin-left-10">
                <img class="qrcode-img" src="../../../../assets/img/official/service2.jpg" alt="">
                <div class="nickname">守兔票务-婷欧尼</div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <sync-template ref="template"></sync-template>
    <admin ref="admin"></admin>
  </div>
</template>

<script>
import SyncTemplate from '@/components/official/SyncTemplate.vue'
import Admin from '@/components/official/Admin.vue'
import { getUserUUID, getNickname, getPlatformUuid, getPlatformName, getHeadImg, getIsAuthOfficial, getSnaphotId, getIsBasic } from '@/utils/auth'
import official from '@/javaApi/official'
const officialModel = new official()
export default {
  name: 'Authorization',
  components: {
    SyncTemplate,
    Admin
  },
  data: function () {
    return {
      isBasic: getIsBasic() === 'true' ? true : false, //是否是基础版本
      listLoading: false,
      userUUID: getUserUUID(),
      bindPackage: [],
      publicInfo: [],
      authLink: process.env.VUE_APP_MOVIE_DOMAIN + 'movie/api/dis.distribution/toauth?openUserName=' + getNickname() + '&openUserUuid=' + getUserUUID() + '&snapshotId=' + getSnaphotId(),
      promotionLink: process.env.VUE_APP_MOVIE_PROMOTION_URL + 'yp-api/movie/wx/pub-login?platformUuid=' + getPlatformUuid() + '&type=1',
      personalLink: process.env.VUE_APP_MOVIE_PROMOTION_URL + 'yp-api/movie/wx/pub-login?platformUuid=' + getPlatformUuid() + '&type=personal',  //个人中心链接
      posterLink: process.env.VUE_APP_MOVIE_PROMOTION_URL + 'yp-api/movie/wx/pub-login?platformUuid=' + getPlatformUuid() + '&type=poster',      //邀请好友链接
      authStep: getIsAuthOfficial() === 'true' ? 2 : 1,
      headImg: getHeadImg(),
      platformName: getPlatformName()
    }
  },
  methods: {
    syncTemplate: function () {
      this.$refs.template.init();
      //https://test.taototo.cn/movie/api/template/addOneTemplate?platformUUID=xxxx
      console.log('同步消息模板')
    },
    bindWechatAdmin: function () {
      this.$refs.admin.init()
      //https://test.taototo.cn/movie/api/dis.user/bindAdmin?adminPlatform=XXXX ---这个是绑定微信管理员 - 扫码绑定（获取二维码链接）
      console.log('绑定微信管理员')
    },
    copyLink: function (link) {
      var that = this
      this.$copyText(link).then(function (e) {
        that.$Message.success('复制成功')
        console.log(e)
      }, function (e) {
        that.$Message.error('复制失败,请升级浏览器版本！')
        console.log(e)
      })
    },
  }
}
</script>

<style scoped>
.margin-left-10 {
  margin-left: 10px;
}

.margin-right-10 {
  margin-right: 10px;
}

.wrapper .tilte-text {
  font-size: 18px;
  color: #222222;
  text-align: left;
  font-weight: bold;
}

.auth-wrap .auth-box {
  padding: 60px 30px;
}

.auth-wrap .auth-box .auth-logo-div {
  padding-right: 30px;
}

.auth-wrap .auth-box .auth-logo {
  width: 100%;
  padding-top: 30px;
}

.auth-wrap .auth-box .auth-title,
.auth-detail .auth-title {
  font-family: Alibaba-PuHuiTi-M;
  font-size: 18px;
  color: #222222;
}

.auth-wrap .auth-box .auth-tip,
.auth-detail .auth-tip {
  font-family: Alibaba-PuHuiTi-R;
  font-size: 13px;
  color: #666666;
  margin-top: 10px;
}

.auth-wrap .auth-box .part-box,
.auth-detail .part-box {
  display: flex;
  flex-direction: row;
  padding: 4px 0;
}

.auth-wrap .auth-box .part-circle,
.auth-detail .part-circle {
  width: 6px;
  height: 6px;
  border-radius: 3px;
  background: #D63036;
  margin: 5px 8px 5px 0;
}

.auth-detail .part-circle {
  background: #999999;
}

.auth-wrap .auth-box .part-content,
.auth-detail .part-content {
  width: 90%;
}

.auth-wrap .auth-box .btn-box {
  padding: 20px 10px;
}

.auth-wrap .auth-box .btn-box .auth-btn {
  font-family: Alibaba-PuHuiTi-R;
  background: #FF8622;
  border-radius: 2px;
  color: #FFFFFF;
  padding: 6px 15px;
}

.auth-wrap .auth-box .btn-box .auth-btn a {
  color: #FFFFFF;
}

.auth-detail {
  padding-top: 30px;
  min-width: 900px;
}

.auth-detail .left-box {
  padding-right: 20px;
}

.auth-detail .left-box .detail-box {
  border: 1px solid #EEEEEE;
  border-radius: 4px;
  min-width: 440px;
}

.auth-detail .left-box .detail-box .detail-div {
  padding: 20px 20px 160px 20px;
}

.auth-detail .left-box .detail-box .detail-div .operate-div {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font-size: 13px;
  color: #FF8622;
  padding: 10px 0;
}

.auth-detail .left-box .detail-box .detail-div .operate-div img {
  width: 60px;
  height: 60px;
  border-radius: 50%;
}

.auth-detail .left-box .detail-box .detail-div .operate-div .wechat-title {
  font-family: Alibaba-PuHuiTi-R;
  font-size: 16px;
  color: #666666;
  width: 130px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  -webkit-line-clamp: 1;
}

.auth-detail .left-box .detail-box .detail-div .operate-div .wechat-btn {
  border: 1px solid #FF8622;
  padding: 6px 15px;
  cursor: pointer;
}

.auth-detail .left-box .detail-box .detail-div .link-div {
  padding-top: 20px;
}

.auth-detail .left-box .detail-box .detail-div .link-title {
  font-family: Alibaba-PuHuiTi-R;
  font-size: 14px;
  color: #222222;
}

.auth-detail .left-box .detail-box .detail-div .link {
  font-family: Alibaba-PuHuiTi-R;
  font-size: 12px;
  color: #3D9EFC;
  padding: 6px 0;
  display: flex;
}

.auth-detail .left-box .detail-box .detail-div .link label {
  width: 100px;
  color: #222222;
}

.auth-detail .left-box .detail-box .detail-div .link-tip {
  font-family: Alibaba-PuHuiTi-R;
  font-size: 12px;
  color: #666666;
}

.auth-detail .right-box {
  padding-left: 20px;
}

.auth-detail .right-box .notice-box {
  min-width: 380px;
}

.auth-detail .right-box .notice-box .qrcode-box {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding-top: 30px;
}

.auth-detail .right-box .notice-box .qrcode-box .qrcode-div {
  border: 1px solid #EEEEEE;
  border-radius: 4px;
  width: 180px;
  padding: 20px;
}

.auth-detail .right-box .notice-box .qrcode-box .qrcode-div .qrcode-img {
  width: 140px;
  height: 140px;
  object-fit: contain;
}

.auth-detail .right-box .notice-box .qrcode-box .qrcode-div .nickname {
  padding-top: 10px;
  text-align: center;
  font-size: 14px;
  color: #222222;
}

.auth-detail .part-content .sync-template {
  color: #FF4F76;
  padding-left: 5px;
  cursor: pointer;
}

.copy-btn {
  border: 1px solid #FF8622;
  padding: 6px 15px;
  cursor: pointer;
  color: #FF8622;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/official/authorization/Index.vue